var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-dialog"},[_c('el-dialog',_vm._b({},'el-dialog',_vm.$attrs,false),[_vm._t("default"),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }